import React, { useState, useEffect } from "react";
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Translate from "../../common/functions/translate";
import { ProductLiteModel } from "../../models/product/productLiteModel";
import { OfferStepModel } from "../../models/offer/offerStepModel";
import { Units } from "../../common/enums";
import * as HelperFunctions from '../../common/functions/helperFunctions';
import { IProduct } from "../../common/appDatabase";
import LocalProductsService from "../../services/localDataServices/localProductsService";

let localProductsService = new LocalProductsService();

const InstallationArticlesList = (props: any) => {
    const [dbProducts, setDbProducts] = useState(Array<IProduct>(0));

    const getInstallationProducts = (): Array<ProductLiteModel> => {
        const offer: OfferStepModel = props.offer;

        let installationProducts = new Array<ProductLiteModel>(0);

        if (props.isGasInstall) {
            if (offer.gasInstallation.products && offer.gasInstallation.products.length > 0) {
                installationProducts.push(...offer.gasInstallation.products.filter(p => p.addedFromPlanner === true));
            }

            if (offer.gasInstallation.additionalProducts && offer.gasInstallation.additionalProducts.length > 0) {
                installationProducts.push(...offer.gasInstallation.additionalProducts.filter(p => p.addedFromPlanner === true));
            }
        } else {
            if (offer.heathInstall.products && offer.heathInstall.products.length > 0) {
                installationProducts.push(...offer.heathInstall.products.filter(p => p.addedFromPlanner === true));
            }

            if (offer.heathInstall.additionalProducts && offer.heathInstall.additionalProducts.length > 0) {
                installationProducts.push(...offer.heathInstall.additionalProducts.filter(p => p.addedFromPlanner === true));
            }
        }

        // Process PIPES
        let pipeInfo = props.isGasInstall ? offer.gasInstallation.pipeInfo : offer.heathInstall.pipeInfo;

        if (pipeInfo && pipeInfo.pipes) {
            pipeInfo.pipes.forEach(pipe => {
                if (pipe.productId) {
                    let dbProduct = dbProducts.find(p => p.remoteId === pipe.productId);

                    if (dbProduct) {
                        let addedPipe = installationProducts.find(p => p.productId === dbProduct?.remoteId);

                        if (addedPipe) {
                            addedPipe.quantity += pipe.pipeLength / 100
                        } else {
                            installationProducts.push(createProductLite(dbProduct.remoteId, dbProduct.articleNumber, dbProduct.article, dbProduct.unitId, pipe.pipeLength / 100));
                        };
                    } else {
                        // PIPES without products
                        if (props.isGasInstall) {
                            let pipeName = !pipe.isUnderground ? Translate('copper pipes') : Translate('underground pipes');

                            if (pipe.diameter && !pipe.isUnderground) {
                                pipeName += ` ф ${pipe.diameter}x${pipe.diameter < 28 ? '1' : '1.5'} mm*`;
                            }

                            let foundPipe = installationProducts.find(p => p.productId === 0 && p.article === pipeName);

                            if (foundPipe) {
                                foundPipe.quantity += pipe.pipeLength
                            } else {
                                installationProducts.push(createProductLite(0, '', pipeName, Units.UnitLinearMeter, pipe.pipeLength / 100));
                            }
                        } else {
                            let pipeName = Translate('polyethylene pipes with aluminum insert');
                            let foundPipe = installationProducts.find(p => p.productId === 0 && p.article === pipeName);

                            if (foundPipe) {
                                foundPipe.quantity += pipe.pipeLength
                            } else {
                                installationProducts.push(createProductLite(0, '', pipeName, Units.UnitLinearMeter, pipe.pipeLength / 100));
                            }
                        }
                    }
                }
            });

            // Process FITTINGS
            let fittings = props.isGasInstall ? offer.gasInstallation.fittings : offer.heathInstall.fittings;

            if (fittings) {
                if (fittings.autoFittings && fittings.autoFittings.length > 0) {
                    fittings.autoFittings.forEach(fitting => {
                        if (fitting.remoteId) {
                            let dbProduct = dbProducts.find(p => p.remoteId === fitting.remoteId);

                            if (dbProduct) {
                                let foundFitting = installationProducts.find(ip => ip.productId === dbProduct?.remoteId);

                                if (foundFitting) {
                                    foundFitting.quantity++;
                                } else {
                                    installationProducts.push(createProductLite(dbProduct.remoteId, dbProduct.articleNumber, dbProduct.article, dbProduct.unitId, 1));
                                }
                            }
                        } else {
                            let fittingName = fitting.diameter ? `${fitting.article} d${fitting.diameter}` : fitting.article;

                            let foundFitting = installationProducts.find(ip => ip.productId === 0 && ip.article === fittingName);

                            if (foundFitting) {
                                foundFitting.quantity++;
                            } else {
                                installationProducts.push(createProductLite(0, '', fittingName, Units.UnitNumber, 1));
                            }
                        }
                    })
                }

                if (fittings.couplingCount) {
                    installationProducts.push(createProductLite(0, '', Translate('Coupling'), Units.UnitNumber, fittings.couplingCount));
                }

                if (fittings.elbowCount) {
                    let elbowFound = installationProducts.find(p => p.productId === 0 && p.article === Translate('Elbow'));

                    if (elbowFound) {
                        elbowFound.quantity += fittings.elbowCount;
                    } else {
                        installationProducts.push(createProductLite(0, '', Translate('Elbow'), Units.UnitNumber, fittings.elbowCount));
                    }
                }

                if (fittings.holenderCount) {
                    installationProducts.push(createProductLite(0, '', Translate('Transitional Holender'), Units.UnitNumber, fittings.holenderCount));
                }

                if (fittings.magnetVentilsCount) {
                    installationProducts.push(createProductLite(0, '', Translate('Magnet Ventil'), Units.UnitNumber, fittings.magnetVentilsCount));
                }

                if (fittings.nipelCount) {
                    installationProducts.push(createProductLite(0, '', Translate('Nipel'), Units.UnitNumber, fittings.nipelCount));
                }

                if (fittings.tripleCount) {
                    let tripleFound = installationProducts.find(p => p.productId === 0 && p.article === Translate('Triple'));

                    if (tripleFound) {
                        tripleFound.quantity += fittings.tripleCount;
                    } else {
                        installationProducts.push(createProductLite(0, '', Translate('Triple'), Units.UnitNumber, fittings.tripleCount));
                    }
                }

                if (fittings.ventilCount) {
                    installationProducts.push(createProductLite(0, '', Translate('Ventil'), Units.UnitNumber, fittings.ventilCount));
                }
            }
        }

        return installationProducts;
    }

    const createProductLite = (productId: number, artNo: string, article: string, unitId: number, qty: number): ProductLiteModel => {
        let productLite = new ProductLiteModel();
        productLite.productId = productId;
        productLite.articleNumber = artNo;
        productLite.article = article;
        productLite.unitId = unitId;
        productLite.quantity = qty;

        return productLite;
    }

    useEffect(() => {
        const offer: OfferStepModel = props.offer;
        let productsIds = new Array<number>(0);

        if (props.isGasInstall) {
            if (offer.gasInstallation.pipeInfo && offer.gasInstallation.pipeInfo.pipes) {
                offer.gasInstallation.pipeInfo.pipes.forEach(pipe => {
                    if (pipe.productId) {
                        if (!productsIds.find(i => i === pipe.productId)) {
                            productsIds.push(pipe.productId);
                        }
                    }
                })
            }

            if (offer.gasInstallation.fittings && offer.gasInstallation.fittings.autoFittings) {
                offer.gasInstallation.fittings.autoFittings.forEach(fitting => {
                    if (fitting.remoteId) {
                        if (!productsIds.find(i => i === fitting.remoteId)) {
                            productsIds.push(fitting.remoteId);
                        }
                    }
                })
            }
        } else {
            if (offer.heathInstall.pipeInfo && offer.heathInstall.pipeInfo.pipes) {
                offer.heathInstall.pipeInfo.pipes.forEach(pipe => {
                    if (pipe.productId) {
                        if (!productsIds.find(i => i === pipe.productId)) {
                            productsIds.push(pipe.productId);
                        }
                    }
                })
            }

            if (offer.heathInstall.fittings && offer.heathInstall.fittings.autoFittings) {
                offer.heathInstall.fittings.autoFittings.forEach(fitting => {
                    if (fitting.remoteId) {
                        if (!productsIds.find(i => i === fitting.remoteId)) {
                            productsIds.push(fitting.remoteId);
                        }
                    }
                })
            }
        }

        if (productsIds.length > 0) {
            localProductsService.getProductsByRemoteId(productsIds).then(
                (dbProducts: any) => {
                    setDbProducts(dbProducts);
                }
            ).catch(error => {
                console.log(error);
            })
        }

    }, [props.offer, props.isGasInstall]);

    let installationProducts = getInstallationProducts();

    return <>
        {installationProducts.length > 0
            ? <TableContainer component={Paper} style={{ maxHeight: "600px" }}>
                <Table stickyHeader size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell><strong>{Translate("Article number")}</strong></TableCell>
                            <TableCell><strong>{Translate("Article")}</strong></TableCell>
                            <TableCell style={{ width: 80 }} align="center"><strong>{Translate("UnitShort")}</strong></TableCell>
                            <TableCell style={{ width: 80 }} align="center"><strong>{Translate("Qty")}</strong></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {installationProducts.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell component="th" scope="row">
                                    {row.articleNumber}
                                </TableCell>
                                <TableCell>{row.article}</TableCell>
                                <TableCell align="center">{HelperFunctions.getEnumLabel(row.unitId, Units, true)}</TableCell>
                                <TableCell align="center">{Number.isInteger(row.quantity) ? row.quantity : row.quantity.toFixed(2)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            : <div style={{ marginTop: 10 }}>{Translate('No articles added to installation')}</div>}
    </>
}

export default InstallationArticlesList;